module.exports = __webpack_public_path__ + "static/media/tring.404207da.svg";